import { createTheme } from '@mui/material';
import _ from 'lodash';
import { getTheme, getThemeOptionsComponents } from './theme';
import { ThemeDatepicker } from './theme/components/datepicker';
import { customerTokens } from './theme-customer-tokens';
import { professionalTokens } from './theme-professional-tokens';
export const professionalThemeWithDatepicker = createTheme(_.merge({}, getTheme(professionalTokens), {
    components: Object.assign({}, ThemeDatepicker),
}));
export const customerThemeWithDatepicker = createTheme(_.merge({}, getTheme(customerTokens), {
    components: Object.assign({}, ThemeDatepicker),
}));
export const getPartialProfessionalThemeWithDatepicker = (...pickedKeys) => createTheme(Object.assign(Object.assign({}, getTheme(professionalTokens)), { components: _.pick(Object.assign(Object.assign({}, getThemeOptionsComponents(professionalTokens)), ThemeDatepicker), pickedKeys) }));
export const getPartialCustomerThemeWithDatepicker = (...pickedKeys) => createTheme(Object.assign(Object.assign({}, getTheme(customerTokens)), { components: _.pick(Object.assign(Object.assign({}, getThemeOptionsComponents(customerTokens)), ThemeDatepicker), pickedKeys) }));
